const ProjectManager = () => import("@/views/projectManager/projectManager.vue");

export default {
  path: "project-manager",
  meta: { label: "Project Manager" },
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "",
      meta: {
        requiresAuth: true,
      },
      component: ProjectManager,
    },
  ],
};
